import React, { Component } from "react";
import { Button, Form, FormText, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import VideoPlayer from "simple-react-video-thumbnail";
import LoaderButton from "../components/LoaderButton";
import congrat from "../images/congrats.svg";
import slide1 from "../images/pup-slide-1.svg";
import { Constants } from "../libs/Constants";
import { getList, update } from "../libs/dbFunctions";
import { getCurrentDate, getValidDate, numberWithCommas } from "../libs/utils";
import ESPPVideo from "../Videos/ESPPVideo.mp4";
import Participation from "../Videos/Participation.mp4";
import "./NonAcceptHome.scss";

const TOTAL_STEPS = 5;

export default class NonAcceptHome extends Component {
  // _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      isLoading: false,
      periodStartdate: "",
      periodEnddate: "",
      plan: {},
      acceptTerms: "off",
      yesToTaabl: "no",
      hasValidPeriod: false,
      enrollStartdate: "",
      enrollEnddate: "",
      nextStepClicked: false,
      scrolled: false,
      carouselStep: 1,
      acceptLending: "off",
      lendingScrolled: false,
      updateClicked: false,
      financingSelected: false,
    };
    this.handleOnscroll = this.handleOnscroll.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFinancing = this.handleFinancing.bind(this);
    this.handleUpdateTerms = this.handleUpdateTerms.bind(this);
    this.submitFinancing = this.submitFinancing.bind(this);
  }
  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  async handleUpdateTerms() {
    this.setState({ updateClicked: true });
    try {
      if (this.state.acceptLending === "on" && !this.state.lendingScrolled) {
        return;
      }
      // check if user has read agreement or user do not want taabl
      if (this.state.acceptLending === "on" || this.state.yesToTaabl === "no") {
        this.setState({ isLoading: true });
        //update user details
        let allowTaabl = false;
        if (this.state.yesToTaabl === "yes") allowTaabl = true;
        let obj = Object.assign({
          ...this.props.userObj,
          acceptTerms: true,
          allowTaabl: allowTaabl,
        });
        await update(Constants.dbTypes.USER, obj);

        if ("offerStartdate" in this.props && this.props.offerStartdate) {
          //Check for remaining Contributions
          let params = {
            userId: this.props.userObj.id,
            companyId: this.props.activeCompany.id,
            offerStartdate: this.props.offerStartdate,
          };
          await update(
            Constants.dbTypes.CONTRIBUTION,
            params,
            this.props.activeCompany.id
          );
        }
        this.setState({
          isLoading: false,
          step: 8,
        });
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
  }

  async componentWillMount() {
    let currentDate = getCurrentDate();
    let dateDiffArray = [];
    try {
      //get plan detail for the company
      const planDetail = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        this.props.activeCompany
      );
      if (planDetail && planDetail.length > 0) {
        this.setState({
          plan: planDetail[0],
          periodsPerAnnum: 12 / Number(planDetail[0].purchasePeriod),
        });
      }
      //fetch the period rows from database
      const periodDetails = await getList(
        Constants.dbTypes.PERIOD,
        this.props.activeCompany
      );
      if (periodDetails && periodDetails.length > 0) {
        periodDetails.map((period) => {
          let period_startdate = getValidDate(period.periodStartdate);
          dateDiffArray.push(
            Math.abs(currentDate.diff(period_startdate, "days"))
          );
        });
        const nearestPeriod = dateDiffArray.indexOf(
          dateDiffArray.reduce((a, b) => Math.min(a, b))
        );
        let enrollSDate = getValidDate(
          periodDetails[nearestPeriod].enrollmentStartDate
        );
        let enrollEDate = getValidDate(
          periodDetails[nearestPeriod].enrollmentEndDate
        );
        let hasValidPeriod = false;
        if (currentDate.isBetween(enrollSDate, enrollEDate))
          hasValidPeriod = true;
        this.setState({
          periodStartdate: getValidDate(
            periodDetails[nearestPeriod].periodStartdate
          ),
          periodEnddate: getValidDate(
            periodDetails[nearestPeriod].periodEnddate
          ),
          enrollStartdate: enrollSDate,
          enrollEnddate: enrollEDate,
          isLoading: false,
          hasValidPeriod: hasValidPeriod,
        });
      } else {
        this.setState({
          isLoading: false,
          hasValidPeriod: false,
        });
      }
    } catch (e) {
      toast.error(e);
    }
  }
  setStep(step) {
    this.setState({ step });
  }
  handleOnscroll(event, type) {
    const form = event.currentTarget;
    let formScrolPosition =
      form.scrollHeight - Math.ceil(form.scrollTop) - form.clientHeight;
    if (formScrolPosition <= 0) {
      if (type === "terms") {
        this.setState({
          scrolled: true,
        });
      } else {
        this.setState({
          lendingScrolled: true,
        });
      }
    }
  }
  async handleSubmit(event) {
    event.preventDefault();
    if (!this.state.scrolled || this.state.acceptTerms !== "on")
      this.setState({ nextStepClicked: true });
    else this.setState({ nextStepClicked: true, step: 5 });
  }
  renderTermsAndConditions() {
    return (
      <Modal.Body>
        <div className="fixed-width">
          <h2>Terms and Conditions</h2>
          {this.state.nextStepClicked && !this.state.scrolled && (
            <FormText className="text-danger">
              {" "}
              Must view all terms and conditions{" "}
            </FormText>
          )}
          <div
            className="plan-scroll thin-scroll"
            onScroll={(e) => this.handleOnscroll(e, "terms")}
          >
            <div className="font-12 font-weight-medium pt-3">
              ToS (Software Usage Only)
            </div>
            <div className="font-12 font-weight-light pt-1">
              First, let’s sign the boring legal stuff so you can login. Our
              attorney’s make us do this.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>
            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>
          </div>
          <Form
            className="mt-2"
            noValidate
            validated={this.state.nextStepClicked}
          >
            <Form.Group
              controlId="acceptTerms"
              size="lg"
              className={`form-group`}
            >
              <Form.Check
                type="checkbox"
                name="terms"
                id="acceptTerms"
                className="pl5"
              >
                <Form.Check.Input
                  type="checkbox"
                  className={
                    this.state.nextStepClicked &&
                      this.state.acceptTerms !== "on"
                      ? "checkboxred"
                      : "pl5"
                  }
                  required
                  onChange={this.handleChange}
                />
                <Form.Check.Label className="display-5">
                  Agree to the Terms and Conditions
                </Form.Check.Label>
              </Form.Check>
            </Form.Group>
            <LoaderButton
              className="mt-1 bnt-plan mb-4"
              id="submit"
              variant="primary"
              isLoading={this.state.isLoading}
              onClick={this.handleSubmit}
            >
              Next Step
            </LoaderButton>
          </Form>
        </div>
      </Modal.Body>
    );
  }

  renderSuccess() {
    return (
      <Modal.Body>
        <img className="d-block w-100" src={congrat} alt="First slide" />
        <div className="text-center">
          <h2>Congratulations!</h2>
          <h6 className="mt-3 mb-3">
            <Button href="/" className="bnt-a cursor-pointer">
              View Dashboard
            </Button>
          </h6>
        </div>
      </Modal.Body>
    );
  }
  renderLendingAgreement() {
    return (
      <Modal.Body>
        <div className="fixed-width">
          <h2>Lending Agreement</h2>
          {this.state.updateClicked && !this.state.lendingScrolled && (
            <FormText className="text-danger">
              {" "}
              Must view all terms and conditions{" "}
            </FormText>
          )}
          <div
            className="plan-scroll thin-scroll"
            onScroll={(e) => this.handleOnscroll(e, "lending")}
          >
            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>
            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="font-12 font-weight-medium pt-3">
              Tempor Incididunt
            </div>
            <div className="font-12 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem
              ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
              tempor incididunt ut labore et dolore magna aliqua.
            </div>
          </div>
          <Form
            className="mt-2"
            noValidate
            validated={this.state.updateClicked}
          >
            <Form.Group
              controlId="acceptLending"
              size="lg"
              className={`form-group`}
            >
              <Form.Check
                type="checkbox"
                name="terms"
                id="acceptLending"
                className="pl5"
              >
                <Form.Check.Input
                  type="checkbox"
                  className={
                    this.state.updateClicked &&
                      this.state.acceptLending !== "on"
                      ? "checkboxred"
                      : "pl5"
                  }
                  required
                  onChange={this.handleChange}
                />
                <Form.Check.Label className="display-5">
                  Agree to the Terms and Conditions
                </Form.Check.Label>
              </Form.Check>
            </Form.Group>
            <LoaderButton
              className="mt-1 bnt-plan mb-4"
              id="submit"
              variant="primary"
              isLoading={this.state.isLoading}
              onClick={this.handleUpdateTerms}
            >
              Submit
            </LoaderButton>
          </Form>
        </div>
      </Modal.Body>
    );
  }
  renderFinancingStep() {
    return (
      <Modal.Body>
        <div className="text-center">
          <h4>Do you want Taabl to Finance your contribution? </h4>
          <div className="mt-3 mb-3">
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio1"
                value="yes"
                onClick={this.handleFinancing}
              ></input>
              <label
                className="form-check-label"
              // for="inlineRadio1"
              >
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="inlineRadio2"
                value="no"
                onClick={this.handleFinancing}
              ></input>
              <label
                className="form-check-label"
              // for="inlineRadio2"
              >
                No
              </label>
            </div>
          </div>
          <LoaderButton
            className="mt-1 bnt-plan mb-4"
            id="back"
            variant="primary"
            isLoading={this.state.isLoading}
            onClick={this.submitFinancing}
            disabled={!this.state.financingSelected}
          >
            Submit
          </LoaderButton>
        </div>
      </Modal.Body>
    );
  }
  handleFinancing(e) {
    this.setState({
      yesToTaabl: e.target.value,
      financingSelected: true,
    });
  }
  submitFinancing() {
    let nextStep = 0;
    if (this.state.yesToTaabl === "yes") nextStep = 6;
    else nextStep = 7;
    this.setState({
      step: nextStep,
    });
  }
  renderEEPage() {
    return (
      <Modal.Body>
        <div className="fixed-width">
          <h2>Plan Details</h2>
          <div className="plan-scroll thin-scroll">
            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>
            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>

            <div className="display-5 fw-bold pt-3">Tempor Incididunt</div>
            <div className="display-5 font-weight-light pt-1">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </div>
          </div>

          <button
            className="btn btn-primary mt-4 bnt-plan mb-4"
            onClick={this.handleUpdateTerms}
          >
            Next Step
          </button>
        </div>
      </Modal.Body>
    );
  }

  renderSecondStep() {
    return (
      <Modal.Body>
        <div className="fixed-width">
          <h5>Activate Taabl</h5>
          <p className="textNormal text-left">
            Log in to Taabl to see which solution is best for you.
          </p>
          <p className="text-left mb-0">
            <ul className="mb-0">
              <li>
                Every {this.state.plan?.purchasePeriod} months, Taabl can
                contribute $
                {numberWithCommas(
                this.state.plan?.maxContribution?.dollar /
                this.state.periodsPerAnnum
              )}{" "}
                in your name.
              </li>
              <li>
                {" "}
                When stock is dispersed, Taabl will be paid back for their
                contribution.
              </li>
            </ul>
          </p>
          <p className="textNormal text-left">
            You can log in and decide if you want to keep your whole paycheck or
            not.
          </p>
          <button
            className="btn btn-primary mt-4 bnt-start mb-4"
            onClick={() => this.setStep(4)}
          >
            Get Started
          </button>
        </div>
      </Modal.Body>
    );
  }

  renderWelcome() {
    return (
      <Modal.Body>
        <div className="fixed-width">
          <img className="image-espp" src={slide1} alt="First slide" />
          <h2 className="mt-5 text-center">Welcome to Taabl</h2>
          <p className="text-left">
            Taabl is the first software to simplify your Employee Stock Purchase
            Plan (ESPP) so that it’s easy to understand. Taabl can also help you
            contribute to your ESPP without a payroll deduction!
          </p>
          <h6 className="mt-3 mb-3">
            <a onClick={() => this.setStep(2)} className="bnt-a cursor-pointer">
              How it works
            </a>
          </h6>
        </div>
      </Modal.Body>
    );
  }

  renderCarouselIndicator() {
    return (
      <ol className="carousel-indicators">
        {[...Array(TOTAL_STEPS)].map((i, index) => {
          return (
            <li
              data-target="#carouselPlan"
              data-slide-to={i}
              className={this.state.carouselStep === index + 1 ? " active" : ""}
            ></li>
          );
        })}
      </ol>
    );
  }

  renderFirstModal() {
    return (
      <Modal.Body>
        <div className="carousel slide" data-ride="carousel" id="carouselPlan">
          <div className="carousel-inner">
            <div
              className={
                `carousel-item` +
                (this.state.carouselStep === 1 ? " active" : "")
              }
            >
              <div className="carousel-caption">
                <div className="d-flex align-items-center">
                  <VideoPlayer
                    className="video-espp"
                    videoUrl={ESPPVideo}
                    snapshotAt={3}
                  />
                  <div className="p-2">
                    <p></p>
                    <h5>What is an ESPP?</h5>
                    <p
                      className="sm-image-espp p-2 text-left"
                      alt="What is an ESPP"
                    >
                      First, Taabl’s goal is to help you understand your ESPP
                      and why it matters. Here’s a video to help you get the
                      basics (It’s less than a minute long.)
                    </p>
                  </div>
                </div>
                {this.renderCarouselIndicator()}
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep + 1,
                      })
                    }
                    className="bnt-a"
                  >
                    Next
                  </a>
                </h6>
                <h6>
                  <a
                    onClick={() => this.setStep(1)}
                    className="secondary font-weight-normal font-12"
                  >
                    Back
                  </a>
                </h6>
              </div>
            </div>
            <div
              className={
                `carousel-item` +
                (this.state.carouselStep === 2 ? "active" : "")
              }
            >
              <img
                className="image-espp"
                src={slide1}
                alt="ESPPs are a Great Benefit"
              />
              <div className="carousel-caption fixed-width text-center">
                <h5>ESPPs are a Great Benefit</h5>
                <div className="text-small text-left">
                  As an employee you have exclusive access to purchase your
                  company stock at a discounted price.
                  <br /> In your ESPP for {this.props.activeCompany.name}, you
                  get to buy company stock at a discount. <br />
                  When you get the stock every {
                    this.state.plan?.purchasePeriod
                  }{" "}
                  months, you can choose to either hold it or sell it.
                </div>
                {this.renderCarouselIndicator()}
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep + 1,
                      })
                    }
                    className="bnt-a"
                  >
                    Next
                  </a>
                </h6>
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep - 1,
                      })
                    }
                    className="secondary font-weight-normal font-12"
                  >
                    Back
                  </a>
                </h6>
              </div>
            </div>

            <div
              className={
                `carousel-item` +
                (this.state.carouselStep === 3 ? "active" : "")
              }
            >
              <div>
                <div className="d-flex align-items-center pb-3">
                  <div className="p-3 fixed-width">
                    <h5>Why Doesn't Everyone Participate?</h5>

                    <p className="text-left">
                      Not everyone is able to participate and that’s okay!
                      Here’s another short video to show how Taabl can help!
                    </p>
                  </div>

                  <VideoPlayer
                    className="video-espp"
                    videoUrl={Participation}
                    snapshotAt={3}
                  />
                </div>
                {this.renderCarouselIndicator()}
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep + 1,
                      })
                    }
                    className="bnt-a"
                  >
                    Next
                  </a>
                </h6>
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep - 1,
                      })
                    }
                    className="secondary font-weight-normal font-12"
                  >
                    Back
                  </a>
                </h6>
              </div>
            </div>
            <div
              className={
                `carousel-item` +
                (this.state.carouselStep === 4 ? "active" : "")
              }
            >
              <img className="image-espp" src={slide1} alt="Why use Taabl?" />
              <div className="carousel-caption fixed-width">
                <h5>Why use Taabl?</h5>
                <p className="text-left">
                  If you want to use this benefit but don’t want the extra
                  up-front cost, Taabl can pay that cost for you. This way, you
                  get to keep your own money and still get more company stock
                  every {this.state.plan?.purchasePeriod} months!
                </p>
                {this.renderCarouselIndicator()}
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep + 1,
                      })
                    }
                    className="bnt-a"
                  >
                    Next
                  </a>
                </h6>
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep - 1,
                      })
                    }
                    className="secondary font-weight-normal font-12"
                  >
                    Back
                  </a>
                </h6>
              </div>
            </div>
            <div
              className={
                `carousel-item` +
                (this.state.carouselStep === 5 ? "active" : "")
              }
            >
              <img className="image-espp" src={slide1} alt="Why use Taabl?" />
              <div className="carousel-caption fixed-width">
                <h5>What’s the Catch?</h5>
                <p className="textNormal text-left">
                  You have the exclusive access to the discounted stock - Taabl
                  just wants to fund your participation and will automatically
                  be paid back  once the stock is dispersed to you. So, you’ll
                  make a little less profit, but with no payroll deductions.
                </p>
                <p className="textNormal text-left">
                  You get to keep your paycheck AND get stock! In short, Taabl
                  only makes money when you make money!
                </p>
                {this.renderCarouselIndicator()}
                <h6>
                  <a
                    onClick={(e) => this.setState({ step: 3 })}
                    className="bnt-a"
                  >
                    Next
                  </a>
                </h6>
                <h6>
                  <a
                    onClick={() =>
                      this.setState({
                        carouselStep: this.state.carouselStep - 1,
                      })
                    }
                    className="secondary font-weight-normal font-12"
                  >
                    Back
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    );
  }

  render() {
    return (
      <Modal
        show={true}
        size="lg"
        backdrop="static"
        dialogClassName="pup-cust"
        backdropClassName="taabl-modal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {this.state.step === 1 && this.renderWelcome()}
        {this.state.step === 2 && this.renderFirstModal()}
        {this.state.step === 3 && this.renderSecondStep()}
        {this.state.step === 4 && this.renderTermsAndConditions()}
        {this.state.step === 5 && this.renderFinancingStep()}
        {this.state.step === 6 && this.renderLendingAgreement()}
        {this.state.step === 7 && this.renderEEPage()}
        {this.state.step === 8 && this.renderSuccess()}
      </Modal>
    );
  }
}
